module.exports = __webpack_public_path__ + "static/media/ks.919faf3c.png";